// import { ctrl as outbound_ioc } from "./outbound_ioc";

export = function (ngModule) {
    ngModule.controller('hybridAlertsSummary', require('./summary'));
    ngModule.controller('hybridAlertsNtaDetails', require('./nta_details'));
    ngModule.controller('hybridAlertsUebaDetails', require('./ueba_details'));
}




/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hybrid_alerts/index.ts
 **/